export default __webpack_public_path__ + "static/media/computerLady3.f620c7a6.jpg";